import { useState } from "react";
import { useTranslation } from "react-i18next";
import { api } from "@/helper/api";

export interface MailRecipient {
  email: string;
  firstName: string;
  lastName: string;
}

export interface SentMail {
  sent_on: string;
  status: string;
  status_color: string;
  template_id: string;
  template_name: string;
}

const statusColor = (status: string) => {
  if (status === "delivered") return "#82C000";
  if (status === "commited" || status === "submitted") return "#FFB000";
  return "#C00000";
};

export function useUserMailLogDialog(onError: (error: any) => void) {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [sentMails, setSentMails] = useState<SentMail[]>([]);
  const [recipient, setRecipient] = useState<MailRecipient>({
    email: "",
    firstName: "",
    lastName: "",
  });

  const showMailsSentToUser = (row: any) => {
    setRecipient({
      email: row.original.email,
      firstName: row.original.first_name,
      lastName: row.original.last_name,
    });
    api.genericApiRequest({
      entity: "mailLog",
      method: "get",
      successHandler: (res: any) => {
        const mails: SentMail[] = [];
        for (const key in res.data.results) {
          const item = res.data.results[key];
          mails.push({
            sent_on: item.sent_on,
            status: t(item.status),
            status_color: statusColor(item.status),
            template_id: item.template.id,
            template_name: item.template.name,
          });
        }
        setSentMails(mails);
        setOpen(true);
      },
      failHandler: (error: any) => {
        onError(error);
      },
      parametersToRender: {
        depth: "0",
        additionalUrlParameters: { user: row.original.id },
      },
    });
  };

  return {
    showMailsSentToUser,
    dialogProps: {
      open,
      onClose: () => setOpen(false),
      recipient,
      sentMails,
    },
  };
}
